/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileMoveEndpointRequest
 */
export interface FileMoveEndpointRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof FileMoveEndpointRequest
     */
    input: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FileMoveEndpointRequest
     */
    destination: string;
    /**
     * 
     * @type {boolean}
     * @memberof FileMoveEndpointRequest
     */
    sync?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FileMoveEndpointRequest
     */
    overwrite?: FileMoveEndpointRequestOverwriteEnum;
}

/**
* @export
* @enum {string}
*/
export enum FileMoveEndpointRequestOverwriteEnum {
    Null = 'null',
    Warn = 'warn',
    Number = 'number',
    Timestamp = 'timestamp',
    Overwrite = 'overwrite'
}

export function FileMoveEndpointRequestFromJSON(json: any): FileMoveEndpointRequest {
    return FileMoveEndpointRequestFromJSONTyped(json, false);
}

export function FileMoveEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileMoveEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'input': json['input'],
        'destination': json['destination'],
        'sync': !exists(json, 'sync') ? undefined : json['sync'],
        'overwrite': !exists(json, 'overwrite') ? undefined : json['overwrite'],
    };
}

export function FileMoveEndpointRequestToJSON(value?: FileMoveEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'input': value.input,
        'destination': value.destination,
        'sync': value.sync,
        'overwrite': value.overwrite,
    };
}


